import * as React from "react";

function SvgInvoiceDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M17.5 2.25h-11C4.98 2.25 3.75 3.48 3.75 5v14c0 1.52 1.23 2.75 2.75 2.75h11c1.52 0 2.75-1.23 2.75-2.75V5c0-1.52-1.23-2.75-2.75-2.75z"
        />
        <path
          fill="#98DB69"
          d="M17.5 3.75c.69 0 1.25.56 1.25 1.25v14c0 .69-.56 1.25-1.25 1.25h-11c-.69 0-1.25-.56-1.25-1.25V5c0-.69.56-1.25 1.25-1.25h11zM16 17.25H8l-.102.007A.75.75 0 008 18.75h8l.102-.007A.75.75 0 0016 17.25zm0-3H8l-.102.007A.75.75 0 008 15.75h8l.102-.007A.75.75 0 0016 14.25zm-6.5-9a.75.75 0 00-.75.75v.025a1.806 1.806 0 00-.136 3.528l1.407.352.063.023a.303.303 0 01-.137.574l-.43-.001L9.5 10.5h-.017l-.358.002-.067-.007a.354.354 0 01-.22-.172l-.059-.083a.75.75 0 00-1.222.864c.27.443.696.754 1.193.859V12l.007.102A.75.75 0 0010.25 12v-.023a1.805 1.805 0 00.136-3.528L8.98 8.098l-.063-.023a.303.303 0 01.137-.574l.432-.001.015.001h.375l.066.007c.086.02.162.077.22.17l.058.084a.75.75 0 001.221-.866c-.27-.44-.694-.75-1.189-.856L10.25 6l-.007-.102A.75.75 0 009.5 5.25zm6.5 4.5h-2l-.102.007A.75.75 0 0014 11.25h2l.102-.007A.75.75 0 0016 9.75zm0-3h-2l-.102.007A.75.75 0 0014 8.25h2l.102-.007A.75.75 0 0016 6.75z"
        />
      </g>
    </svg>
  );
}

export default SvgInvoiceDuo;
